// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"About_wrapper__ixZBN","aboutGrid":"About_aboutGrid__YF1YL","content":"About_content__236gv","contentBackground":"About_contentBackground__2y77w"};